export default __webpack_public_path__ + "static/media/upload_file_icon.e01108f6.svg";